export default "__VITE_ASSET__H0Rt6qxU__"